module.exports = __webpack_public_path__ + "img/ysgj_013@2x.ec659cc6.png";